<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学校管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="请输入关键字" v-model="queryInfo.LoginAccount" clearable @clear="getSchoolList(1)">
            <el-button slot="append" icon="el-icon-search" @click="getSchoolList(1)"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" @click="showEditCreate('add')">添加学校会员</el-button>
          <el-button type="primary" @click="export2Excel()">导出excel</el-button>
          <el-button type="success" @click="exportgo()">导入学校</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="LoginAccount" label="会员账号">
        </el-table-column>
        <el-table-column prop="PersonInCharge" label="负责人">
        </el-table-column>
        <el-table-column prop="Email" label="邮箱"> </el-table-column>
        <el-table-column prop="PhoneNum" label="手机号"> </el-table-column>
        <el-table-column prop="Region" label="所属地区"> </el-table-column>
        <el-table-column prop="SchoolName" label="学校名称"> </el-table-column>
        <el-table-column prop="BuildType" label="创建类型">
          <template slot-scope="scope">
            <div>
              {{ scope.row.BuildType === 0 ? '注册用户' : '管理员添加' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="AuditStatus" label="审核状态" width="70">
          <template slot-scope="scope">
            <span style="color:green" v-if="scope.row.AuditStatus === 1">已审核</span>
            <span style="color:red" v-if="scope.row.AuditStatus === 0">未审核</span>
            <!-- <el-switch
              v-model="scope.row.AuditStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="setAuditStatus(scope.row)"
            >
            </el-switch> -->
          </template>
        </el-table-column>
        <el-table-column prop="RegTime" label="注册时间" :formatter="dataFormat">
        </el-table-column>
        <el-table-column label="操作" width="310">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditCreate('edit', scope.row)">修改</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteCreate(scope.row.SchoolID)">删除</el-button>
            <el-button type="success" icon="el-icon-setting" size="mini" @click="setAuditStatus(scope.row)"
                       v-if="scope.row.AuditStatus === 0">通过</el-button>
            <el-button type="warning" icon="el-icon-setting" size="mini" @click="setAuditStatus(scope.row)"
                       v-if="scope.row.AuditStatus === 1">拒绝</el-button>
            <el-button type="warning" icon="el-icon-setting" size="mini" @click="resetPwd(scope.row.SchoolID)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
                     :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                     background>
      </el-pagination>

      <!-- 修改 -->
      <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="30%" @close="editresetFields">
        <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
          <el-form-item label="会员账号" prop="LoginAccount">
            <el-input v-model="editForm.LoginAccount" :disabled="userstatus" placeholder="账号默认密码：8888"></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="PersonInCharge">
            <el-input v-model="editForm.PersonInCharge"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="Email">
            <el-input v-model="editForm.Email"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="PhoneNum">
            <el-input v-model="editForm.PhoneNum"></el-input>
          </el-form-item>
          <el-form-item label="所属地区" prop="Region">
            <el-select v-model="editForm.Region" placeholder="请选择">
              <el-option v-for="item in regionOptions" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校" prop="SchoolName">
            <el-input v-model="editForm.SchoolName"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()" :loading="isLoading">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 导入学校 -->
      <el-dialog title="导入学校账号" :visible.sync="schoolshow" width="30%">
        <el-form :model="schoolForm" ref="schoolFormRef" label-width="100px" :rules="rules">
          <el-form-item label="模板文件" prop="tempFile">
            <el-upload class="avatar-uploader" ref="uploadref" action="uploadUrlAPI" :limit="1" :on-exceed="handleExceed" :show-file-list="false"
                       :on-change="uploadChange" :on-success="handleAvatarSuccess" :auto-upload="false" :file-list="fileList" accept=".xls,.xlsx">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" style="color: #666">
                只能上传.xls,.xlsx文件，且不超过50MB
              </div>
            </el-upload>
            <div v-if="schoolForm.tempFile">
              <a :href="schoolForm.tempFile"><img src="@/assets/excel.png" alt="excel" /></a>
              <el-button @click="removeFile" size="mini" type="warning" style="position: relative; top: -10px; margin-left: 10px">移除</el-button>
            </div>
            <div class="downfile">
              <a href="../../../file/高校账号导入模板.xlsx" download style="color: green">高校账号导入模板</a>
              <p style="color: #666">
                格式说明：<br />
                1、请按示例模板进行修改<br />
                2、请勿修改模板结构，否则可能导致添加模板失败
              </p>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 账号审核 -->
      <!-- <el-dialog title="账号审核" :visible.sync="AStatus" width="30%">
        账号信息
        <span slot="footer" class="dialog-footer">
          <el-button @click="AStatus = false">取 消</el-button>
          <el-button
            type="primary"
            @click="setAuditStatus(Alist)"
            :loading="isLoading"
            >审核</el-button
          >
        </span>
      </el-dialog> -->
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    // 自定义验证规则
    var rulePhone = (rule, value, cb) => {
      // 手机号正则
      const regMobile =
        /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (regMobile.test(value)) {
        return cb() // 验证合法有效
      }
      cb(new Error('请输入合法手机号'))
    }
    var Email = (rule, value, cb) => {
      // 邮箱
      const regEmail = new RegExp(
        '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
      )
      if (!regEmail.test(value)) {
        cb(new Error('请输入正确的邮箱'))
      } else {
        cb()
      }
    }
    var isChinese = (rule, value, cb) => {
      // 不能使用中文正则
      const regChinese = /^[^\u4e00-\u9fa5]*$/
      if (!regChinese.test(value)) {
        cb(new Error('账号不能使用中文'))
      } else {
        cb()
      }
    }
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        LoginAccount: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 修改表单
      editForm: {
        LoginAccount: '',
        LoginPwd: '',
        PersonInCharge: '',
        Email: '',
        PhoneNum: '',
        Region: '',
        SchoolName: ''
        // AuditStatus: 1,
        // Peg: 1
      },
      // 修改表单验证
      editRules: {
        LoginAccount: [
          {
            required: true,
            message: '请输入会员账号',
            trigger: 'blur'
          },
          {
            validator: isChinese,
            trigger: 'blur'
          }
        ],
        LoginPwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        PersonInCharge: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ],
        Email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          },
          {
            validator: Email,
            trigger: 'blur'
          }
        ],
        PhoneNum: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: rulePhone,
            trigger: 'blur'
          }
        ],
        Region: [
          {
            required: true,
            message: '请选择地区',
            trigger: 'change'
          }
        ],
        SchoolName: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur'
          }
        ]
      },
      // 地区
      regionOptions: [
        {
          value: '1',
          label: '北京市'
        },
        {
          value: '2',
          label: '天津市'
        },
        {
          value: '3',
          label: '上海市'
        },
        {
          value: '4',
          label: '重庆市'
        },
        {
          value: '5',
          label: '河北省'
        },
        {
          value: '6',
          label: '山西省'
        },
        {
          value: '7',
          label: '辽宁省'
        },
        {
          value: '8',
          label: '吉林省'
        },
        {
          value: '9',
          label: '黑龙江省'
        },
        {
          value: '10',
          label: '江苏省'
        },
        {
          value: '11',
          label: '浙江省'
        },
        {
          value: '12',
          label: '福建省'
        },
        {
          value: '13',
          label: '江西省'
        },
        {
          value: '14',
          label: '山东省'
        },
        {
          value: '15',
          label: '四川省'
        },
        {
          value: '16',
          label: '河南省'
        },
        {
          value: '17',
          label: '湖北省'
        },
        {
          value: '18',
          label: '湖南省'
        },
        {
          value: '19',
          label: '广东省'
        },
        {
          value: '20',
          label: '海南省'
        },
        {
          value: '21',
          label: '贵州省'
        },
        {
          value: '22',
          label: '云南省'
        },
        {
          value: '23',
          label: '陕西省'
        },
        {
          value: '24',
          label: '甘肃省'
        },
        {
          value: '25',
          label: '青海省'
        },
        {
          value: '26',
          label: '台湾省'
        },
        {
          value: '27',
          label: '广西'
        },
        {
          value: '28',
          label: '内蒙'
        },
        {
          value: '29',
          label: '西藏'
        },
        {
          value: '30',
          label: '安徽省'
        },
        {
          value: '31',
          label: '宁夏'
        },
        {
          value: '32',
          label: '新疆'
        },
        {
          value: '33',
          label: '香港'
        },
        {
          value: '34',
          label: '澳門'
        }
      ],
      // 学历
      educationOptions: [
        {
          value: '1',
          label: '大专'
        },
        {
          value: '2',
          label: '本科'
        },
        {
          value: '3',
          label: '研究生'
        },
        {
          value: '4',
          label: '博士'
        }
      ],
      // 会员账号编辑状态
      userstatus: false,
      // 按妞加载中
      isLoading: false,
      accountStatus: false,
      // 审核状态弹窗
      AStatus: false,
      // 当前一条学校信息
      Alist: '',
      // 导入学校账号弹窗
      schoolshow: false,
      fileList: [],
      schoolForm: {
        tempFile: ''
      },
      rules: {
        tempFile: [
          {
            required: true,
            message: '此字段为必填',
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    //   默认获取列表
    this.getSchoolList(1)
  },
  methods: {
    // 导入学校账号
    exportgo() {
      this.schoolshow = true
    },
    handleSubmit() {
      this.$refs.schoolFormRef.validate((valid) => {
        if (valid) {
          const ParameterModel = new FormData()
          ParameterModel.append('file', this.fileList[0].raw)
          console.log(ParameterModel)
          // 导入
          this.$http
            .post('/api/School/ImportSchool', ParameterModel)
            .then(async (res) => {
              if (res.data.StatusCode === 1) {
                this.schoolshow = false
                this.$message.success(res.data.Msg)
                this.getSchoolList(1)
              } else {
                this.$message.error(res.data.Msg)
                return false
              }
            })
        } else {
          console.log('验证未通过')
          return false
        }
      })
    },
    handleAvatarSuccess() {
      this.$message.success('成功')
    },
    uploadChange(file, fileList) {
      this.fileList = fileList
      var fileSize = file.size / 1024 / 1024 < 50
      if (!fileSize) {
        this.$message.warning('上传文件大小不能超过 50MB!')
        this.clearfile()
        return false
      }
      if (this.schoolForm.tempFile === '') {
        this.schoolForm.tempFile = URL.createObjectURL(file.raw)
      }
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]
      }
      return true
    },
    removeFile() {
      this.schoolForm.tempFile = ''
      this.clearfile()
    },
    clearfile() {
      // 清空文件列表
      this.$refs.uploadref.clearFiles()
      console.log(this.fileList)
    },
    handleExceed(files, fileList) {
      console.log(fileList)
      this.$message.warning('最多可以上传1个文件')
    },
    //   获取列表
    async getSchoolList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get('/api/School/GetSchools', {
        params: this.queryInfo
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.schools
      this.total = res.Data.total
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getSchoolList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getSchoolList(newPage)
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.userstatus = false
      this.editForm = {
        LoginAccount: '',
        LoginPwd: '',
        PersonInCharge: '',
        Email: '',
        PhoneNum: '',
        Region: '',
        SchoolName: '',
        RegTime: ''
      }
      this.$refs.editFormRef.resetFields()
    },
    // 显示修改弹窗
    showEditCreate(type, row) {
      if (type === 'add') {
        this.dialogTitle = '添加学校会员'
      } else if (type === 'edit') {
        this.$nextTick(() => {
          // 注意看这里
          this.dialogTitle = '编辑学校会员'
          this.userstatus = true
          this.editForm = JSON.parse(JSON.stringify(row))
        })
      }
      this.editDialogVisible = true
    },
    // 添加/修改
    editCreate() {
      this.$refs.editFormRef.validate(async (valid) => {
        this.isLoading = true
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/School/EditSchool',
          this.editForm
        )
        console.log(res)
        // 判断状态码
        if (res.StatusCode !== 1) {
          this.isLoading = false
          return this.$message.error(res.Msg)
        }
        // 成功提示
        this.$message.success(res.Msg)
        this.isLoading = false
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getSchoolList(this.queryInfo.pagenum)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/School/DelSchoolManagementInfo?SchoolID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getSchoolList(this.queryInfo.pagenum)
    },
    // 重置密码
    async resetPwd(id) {
      // 提示用户输入新密码，默认值为8888
      const res = await this.$prompt(
        '请输入重置密码，默认不填写，密码为：8888',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          defaultValue: '8888' // 设置默认值为8888
        }
      ).catch((err) => {
        return err // 如果用户取消，返回 null
      })
      // 如果用户没有输入新密码（例如点击了取消按钮）
      if (res.action !== 'confirm') return this.$message.info('已取消重置密码')
      // 使用用户输入的新密码（如果用户输入了值）或默认值（如果用户没有输入值）
      const newPassword = res.value || '8888' // 如果value为空，则使用默认值8888
      // 发送请求
      const { data: resdel } = await this.$http.get(
        '/api/School/ResetPassword',
        {
          params: { schoolID: id, newPwd: newPassword }
        }
      )
      if (resdel.StatusCode !== 1) return this.$message.error('重置密码失败')
      this.$message.success('重置密码成功')
    },
    // 导出excel
    export2Excel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require('../../excel/Export2Excel')
        const tHeader = [
          '会员账号',
          '姓名',
          '邮箱',
          '手机号',
          '所属地区',
          '学校名称',
          '创建类型',
          '审核状态',
          '注册时间'
        ]
        const filterVal = [
          'LoginAccount',
          'PersonInCharge',
          'Email',
          'PhoneNum',
          'Region',
          'SchoolName',
          'BuildType',
          'AuditStatus',
          'RegTime'
        ]
        const list = this.pagedata
        const data = this.formatJson(filterVal, list)
        const tableFileName = '学校信息' + this.setTableFileName()
        exportJsonToExcel(tHeader, data, tableFileName)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    setTableFileName() {
      return this.$moment(new Date()).format('YYYYMMDDHHmmss')
    },
    // 审核弹窗
    // AuditStatusDialog(row) {
    //   this.AStatus = true
    //   this.Alist = row
    //   console.log(this.Alist)
    // },
    // 修改账号状态
    async setAuditStatus(obj) {
      const { data: res } = await this.$http.post(
        '/api/School/ModAccountStatus',
        {
          SchoolID: obj.SchoolID,
          AuditStatus: obj.AuditStatus
        }
      )
      console.log(res)
      if (res.Msg === '已审核') {
        this.$message.success(res.Msg)
      } else if (res.Msg === '未审核') {
        this.$message.error(res.Msg)
      } else {
        this.$message.error('审核未成功')
      }

      // 刷新列表
      this.getSchoolList(this.queryInfo.pagenum)
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less" scoped>
.el-date-editor.el-input {
  width: 100% !important;
}
.red {
  color: red;
}
.green {
  color: green;
}
</style>
